import { Box, TextField, Typography } from "@mui/material";
import React from "react";
import customInputFieldsStyles from "./CustomInputFieldsStyles";
import { Asterisk } from "phosphor-react";

const CustomInputFieldWithFormik = ({
  label,
  name,
  formik,
  isRequired,
  isDisabled = false,
}) => {
  const classes = customInputFieldsStyles();
  return (
    <Box>
      <Box display="flex" alignItems="center" gap="6px">
        <Typography>{label}</Typography>
        {isRequired ? <Asterisk color="red" /> : ""}
      </Box>
      <Box style={{ marginTop: "5px" }} className={classes.cardContentDiv3}>
        <TextField
          name={name}
          value={formik.values[name]}
          onChange={formik.handleChange}
          className={classes.cardContentInput1}
          disabled={isDisabled}
          sx={{
            "& .MuiInputBase-input": {
              padding: "6px",
              backgroundColor: "transparent",
              opacity: 1,
              fontSize: "16px",
              color: "white",
              fontFamily: "poppins",
            },
            "& .MuiOutlinedInput-root": {
              borderRadius: "4px",
              "& fieldset": {
                borderColor: "transparent",
              },
              "&:hover fieldset": {
                borderColor: "transparent",
              },
              "&.Mui-focused fieldset": {
                borderColor: "transparent",
              },
            },
            "&.Mui-disabled .MuiInputBase-input": {
              color: "gray",
            },
          }}
          fullWidth
        />
      </Box>
    </Box>
  );
};

export default CustomInputFieldWithFormik;
